import React from 'react'
import { Tooltip } from 'antd'

interface IComingSoonTooltipProps {
    children: React.ReactNode
}

const ComingSoonTooltip = ({children}: IComingSoonTooltipProps) => {
  return (
    <Tooltip title="Coming Soon">{children}</Tooltip>
  )
}

export default ComingSoonTooltip